'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import { randomBetween } from 'utils/math'
import { AnimatedNumber } from '@repo/web-ui/components/animated-number'

const randomStart = randomBetween(10_000_000, 11_000_000)

export interface TextWithAnimatedCountProps {
  translationKey: string
  className?: string
  step?: number
  isLoading: boolean
  value: number
}

export function TextWithAnimatedCount({
  translationKey,
  className,
  step = 500,
  isLoading,
  value,
}: TextWithAnimatedCountProps) {
  const t = useTranslations()

  const [currentValue, setCurrentValue] = React.useState(randomStart)

  React.useEffect(() => {
    if (isLoading) {
      // Start a temporary animation while loading
      const loadingInterval = setInterval(() => {
        setCurrentValue(prev => prev + step) // Increment the value
      }, 100)

      return () => clearInterval(loadingInterval) // Clear the interval on unmount or when loading ends
    } else if (value !== undefined) {
      setCurrentValue(value) // Update the value when data is available
    }
  }, [isLoading, value, step, currentValue])

  return (
    <>
      {t.rich(translationKey, {
        br: () => <br />,
        number: () => <AnimatedNumber className={className} value={currentValue} />,
      })}
    </>
  )
}
